export const trackingMethods = [
  { label: 'Card', value: 'CARD_LINKED' },
  { label: 'Open Banking', value: 'OPEN_BANKING' },
];
